export default __webpack_public_path__ + "static/media/logo-us-walmart.8cc70e49.svg";